import { render } from "./BrendsComponent.vue?vue&type=template&id=25af7cc6&scoped=true"
import script from "./BrendsComponent.vue?vue&type=script&lang=js"
export * from "./BrendsComponent.vue?vue&type=script&lang=js"

import "./BrendsComponent.vue?vue&type=style&index=0&id=25af7cc6&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25af7cc6"]])

export default __exports__